import { render } from "./container.md?vue&type=template&id=274cf5e5"
import script from "./container.md?vue&type=script&lang=js"
export * from "./container.md?vue&type=script&lang=js"
script.render = render

export default script